const LOCAL_ACCESS_TOKEN_STORE_KEY = 'CurrentUserAccessToken';

const AppAccessToken = {

  storeAccessToken(accessToken) {
    const accessTokenString = JSON.stringify({ accessToken });
    sessionStorage.setItem(LOCAL_ACCESS_TOKEN_STORE_KEY, accessTokenString);
  },

  getAccessToken() {
    const props = sessionStorage.getItem(LOCAL_ACCESS_TOKEN_STORE_KEY);
    const accessTokenString = props || JSON.stringify({});
    const { accessToken } = JSON.parse(accessTokenString);
    return accessToken;
  },

  deleteAccessToken() {
    sessionStorage.removeItem(LOCAL_ACCESS_TOKEN_STORE_KEY);
  }

}

export default AppAccessToken;


// WEBPACK FOOTER //
// ./src/api/appAccessToken.js